import React from 'react';
import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { ModalContainer } from 'components/core';
import { withModalControlsHook, ModalComponentProps } from 'components/modals/with-modal-controls-hook';
import { DeleteAccountModal } from './delete-account-modal';

export type OnCloseResolvedValue = undefined;
export type OnOpenDataValue = {
  afterDelete: () => void;
};

type DeleteAccountModalProps = ModalComponentProps<OnOpenDataValue>;

const DeleteAccountModalWrapper = ({ onClose, data, containerProps }: DeleteAccountModalProps): JSX.Element => (
  <ModalWrapper open>
    <ModalContainer width='500px' padding='24px' {...containerProps}>
      <DeleteAccountModal onClose={onClose} afterDelete={data.afterDelete} />
    </ModalContainer>
  </ModalWrapper>
);

const [DeleteAccountController, useDeleteAccountModal] = withModalControlsHook<OnOpenDataValue>(
  DeleteAccountModalWrapper
);

export { useDeleteAccountModal, DeleteAccountController as DeleteAccount };
